import { radiansToDegrees } from './radians-to-degrees.js';
import { zeroPoint } from './inc.js';

var angle = function (a, b) {
    if (b === void 0) { b = zeroPoint; }
    return radiansToDegrees(Math.atan2(b.y - a.y, b.x - a.x));
};

export { angle };



//////////////////
// WEBPACK FOOTER
// ./node_modules/popmotion/dist/es/utils/angle.js
// module id = null
// module chunks = 